import React from 'react';
import "./style/style-mob.css";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import img from "../../resources/logo.webp"

const translationMap = {
    "DODATNO PRANJE KOSE" : "EXTRA HAIR WASH",
    "SKIDANJE BRADE" : "BEARD REMOVAL",
    "BRADA CLASSIC SREDNJA" : "BEARD CLASSIC MID",
    "BRADA CLASSIC DUGAČKA" : "BEARD CLASSIC LONG",
    "CLASSIC NULERICA" : "CLASSIC ZERO",
    "CLASSIC KRATKA KOSA" : "CLASSIC SHORT HAIR",
    "CLASSIC DUŽA KOSA" : "CLASSIC LONG HAIR"
}

export const ReservationResponse = () => {
    const [language, setLanguage] = React.useState("10"); 
    const navigate = useNavigate();
    const location = useLocation();
    const { date, time, haircut, client, phone, email, successfull} = location.state || {};

    React.useEffect(() => {
        const storedLanguage = localStorage.getItem("selectedLanguage");
        if (storedLanguage) {
            setLanguage(storedLanguage);
        }
    
        const handleStorageChange = () => {
            setLanguage(localStorage.getItem("selectedLanguage") || "10");
        };
    
        window.addEventListener("storage", handleStorageChange);
    
        return () => {
            window.removeEventListener("storage", handleStorageChange);
        };
    }, []);

    const handleLogin = () => {
          navigate("/");
      };

      return (
        <div className="barber-zajednica-admin-page">
            <div className="barber-zajednica-admin-background"></div>
            <h1 style={{fontSize:"40px"}}>{language == 20 ? 'Appointment Overview' : 'Pregled Termina'}</h1>
            {successfull && <div className="barber-zajednica-response-info" style={{zIndex:"10"}}> 
                <div style={{maxHeight: "90px", width: "80%", overflow:"auto"}}><span className='barber-zajednica-reserve-appointment-item'>{language == 20 ? 'Date :' : 'Datum :'} </span>{date}</div>
                <div style={{maxHeight: "90px", width: "80%", overflow:"auto"}}><span className='barber-zajednica-reserve-appointment-item'>{language == 20 ? 'Time :' : 'Vreme :'} </span>{time}</div>


                <div style={{ width: "80%", overflow: "auto" }}>
                {haircut
                    ?.split("#") 
                    .filter((h) => h.trim() !== "") 
                    .map((h, index) => (
                    <div key={index}>
                        <div>
                        <span className="barber-zajednica-reserve-appointment-item">{language == 20 ? 'Service: ' : 'Usluga: '}</span>
                        {language == 20 ? (translationMap[h.split("-")[0].trim()] || h.split("-")[0]) : h.split("-")[0]}
                        </div>
                    </div>
                    ))}
                </div>

                <div style={{ width: "80%", overflow: "auto" }}>
                {haircut && (
                    <div>
                    <span className="barber-zajednica-reserve-appointment-item">{language == 20 ? 'Total price: ' : 'Ukupna cena: '}</span>
                    {haircut
                        .split("#") // Split haircuts by '#'
                        .filter((h) => h.trim() !== "") // Remove empty strings caused by trailing '#'
                        .reduce((total, h) => {
                        const price = parseFloat(h.split("-")[1].replace("RSD", "").trim()); // Extract and parse the price
                        return total + price;
                        }, 0)}{" "}
                    RSD
                    </div>
                )}
                </div>

                <div style={{maxHeight: "90px", width: "80%", overflow:"auto"}}><span className='barber-zajednica-reserve-appointment-item'>{language == 20 ? 'Client :' : 'Klijent :'}  </span>{client}</div>
                <div style={{maxHeight: "90px", width: "80%", overflow:"auto"}}><span className='barber-zajednica-reserve-appointment-item'>{language == 20 ? 'Telephone :' : 'Telefon :'}  </span>{phone}</div>
            </div>}
            <div>
                {successfull ? (
                    <div style={{color: "#be9455", marginTop: "40px"}}>
                        {language == 20 ? 'Successfully Reserved !' : 'Termin uspešno zakazan !'}
                    </div>
                ) : (
                    <div>
                    <div style={{color: "rgb(163, 38, 38)"}}>
                            {language == 20 ? 'An error occured' : 'Došlo je do greške.'}
                        </div>
                        <div style={{color: "rgb(163, 38, 38)"}}>
                            {language == 20 ? 'Please try again' : 'Termin je u medjuvremenu'}
                        </div>
                        <div style={{color: "rgb(163, 38, 38)"}}>
                            {language == 20 ? 'Please try again' : 'rezervisan. Molimo vas da'}
                        </div>
                        <div style={{color: "rgb(163, 38, 38)"}}>
                            {language == 20 ? 'Please try again' : 'pokušate ponovo.'}
                        </div>
                    </div>
                )}
            </div>
            <button className="barber-zajednica-login-button" onClick={handleLogin}> 
                {language == 20 ? 'Back to home page' : 'Nazad na početnu stranu'}
            </button>
            <div className="barber-zajednica-admin-logo">
                <img src={img} alt="Logo" />
            </div>
        </div>
      );
}